// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"137":"040a6fb6","434":"ec61df4b","483":"051b25bf"}[chunkId] + ".chunk.css";
};